import {FilterParameterApiModel} from '../../../api/models/filter-parameter.api.model';

export function buildUserReferenceFilters(userReferences: Array<string | null | undefined>): FilterParameterApiModel[] {
  const slugFilters = new Set<string>();
  const idFilters = new Set<string>();

  userReferences.forEach((reference) => {
    if (typeof reference !== 'string' || !reference.trim()) {
      return;
    }

    const tail = reference.split('/').filter(Boolean).pop() || '';
    if (!tail) {
      return;
    }

    if (/^\d+$/.test(tail)) {
      idFilters.add(tail);
      return;
    }

    slugFilters.add(tail);
  });

  return [
    ...Array.from(slugFilters).map((slug) => new FilterParameterApiModel('slug', slug, 'array')),
    ...Array.from(idFilters).map((id) => new FilterParameterApiModel('id', id, 'array'))
  ];
}
